<template>
<div>
    <v-main>
    </v-main>
</div>
</template>

<script>
export default {
    name: "moreInfo",
    data(){
    }
}
</script>

<style scoped>

</style>